export const environment = {
    name: 'qual',

    production: true,
    localTranslations: false,

    apiDomain: 'qual-hapy.bizzdev.net',
    apiUrl: 'https://qual-hapy.bizzdev.net/api/',
    identityApiUrl: 'https://qual-hapy.bizzdev.net/identity/',
    citizenUrl: 'http://qual-hapycitizen.bizzdev.net',
    appName: "Symia",

    tokenKey: 'token',
    tokenExpKey: 'token-exp',
    rfTokenKey: 'rf-token',

    language: 'language', // clés session storage
    editable: 'editable',
    directoryModel: 'directoryModel',
    wordSearched: 'wordSearched',
    provider: 'pvCode',

    version: require('../../package.json').version,
    build: require('../../package.json').build,

    // BIZZMINE
    bizzmineUrl: 'https://bizzmine.bizzdev.net/login?projectinfo=', // Prod Redmine API KEY
    // bizzmineApiKey: 'b0b7fb404ba66a6a8cd0474e984d669dc3ba94ec', // Dev Redmine API KEY
    bizzmineApiKey: '07fd7dfd92ac74fefcd4cc0b68a39e2b236c5a83',
    bizzmineDashboardUrl: 'https://bizzmine.bizzdev.net/api',
    bizzmineApiKeyDashboard: 'e07b6b2371d0f5eb0a3b45757245e5223f92b112',
    bizzmineProjectName: 'Symia',
    customFieldEmail: 122,
    customFieldLanguage: 123,
    customFieldCommune: 112,
    customFieldContact: 113
};
